import React from 'react'
import ImpressumEN from './impressum/ImpressumEN'
import ImpressumDE from './impressum/ImpressumDE'
import useLanguage from '@hooks/useLanguage.hook'

const Impressum = () => {
    const [lng] = useLanguage()

    return <div>{lng.includes('en') ? <ImpressumEN /> : <ImpressumDE />}</div>
}

export default Impressum
